import { NotificationsService } from 'angular2-notifications';
import { timeout, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { AuthService } from '@auth/auth.service';
import { WorkspaceNewSaveDto } from '@dto/workspace-new-save-dto';
import { WorkspaceNewDto } from '@dto/workspacenew.dto';
import { PositionDto } from '@dto/position.dto';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { Box } from '@business/home/workspace-new/workspace-new.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '@utils/constants';
import { CustomWorkspaceItemMultipleDto } from '@dto/custom-workspace-item-multiple.dto';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class WorkspaceNewService {

  private userWorkspaces = [];
  private wksPredefined = [];
  private wksSelectedId: number | string = Number(0);
  private _workspaceSelected = new BehaviorSubject<number | string>(0);
  whitelabel = this.configService.getConfigWhitelabel();
  isRanking = this.whitelabel.system.cod !== WhitelabelEnum.RANKING;

  workspaceSelected$ = this._workspaceSelected.asObservable();

  private _showAddWorkspaces = new BehaviorSubject<boolean>(true);
  showAddWorkspaces$ = this._showAddWorkspaces.asObservable();

  private _showMessageToAddWks = new BehaviorSubject<boolean>(false);
  showMessageToAddWks$ = this._showMessageToAddWks.asObservable();

  private _workspaceLock = new BehaviorSubject<boolean>(undefined);
  workspaceLock$ = this._workspaceLock.asObservable();

  public _successAddComponent = new BehaviorSubject<any>(null);
  _successAddComponent$ = this._successAddComponent.asObservable();

  public _openTradingView = new BehaviorSubject<boolean>(true);
  _openTradingView$ = this._openTradingView.asObservable();

  private _resizeComponent = new BehaviorSubject<{ componentId: number, cols: number, rows: number }>(null);
  resizeComponent$ = this._resizeComponent.asObservable();

  private _initialWorkspaceId = new BehaviorSubject<any>(null);
  initialWorkspaceId$ = this._initialWorkspaceId.asObservable();

  private _onRemoveWKSItem = new BehaviorSubject<any>(null);
  onRemoveWKSItem$ = this._onRemoveWKSItem.asObservable();

  private _onAddWKSItem = new BehaviorSubject<any>(null);
  onAddWKSItem$ = this._onAddWKSItem.asObservable();

  private _onWorkspaceChange = new BehaviorSubject<any>(null);
  onWorkspaceChange$ = this._onWorkspaceChange.asObservable();

  private isDefaultWorkspace = false;

  constructor(
    private serviceHTTP: HttpService,
    private configService: ConfigService,
    private authService: AuthService,
    private httpClient: HttpClient,
    private notificationService: NotificationsService,
  ) {
    this.wksSelectedId = this.configService.getCookieWorkspace();
    this._initialWorkspaceId.next(this.wksSelectedId);
  }

  loadPredefinedWorkspaces(): Observable<Array<any>> {
    if (this.wksPredefined.length == 0) {
      const isTokenUserMultiBroker = this.isRanking && this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      // return this.serviceHTTP.doGet(this.configService.getApiWorkspace(), 'api/' + this.configService.getUserWorkspacesPreDefineds() + '/workspace', null, isTokenUserMultiBroker)
      return this.httpClient.get(`${this.configService.getApiWorkspace()}/api/${this.configService.getUserWorkspacesPreDefineds()}/workspace`)
        .pipe(timeout(20000),
          catchError(() => {
            // return front default workspace
            this.configService.setCookieWorkspace(Constants.WKS_NAME_OFFLINE);
            return of(Constants.OFFLINE_DEFAULT_WORKSPACE);
          }),
          map((response: any) => {
            if (response && response._isScalar !== false) {
              this.wksPredefined = [...response.Data];
            }
            return this.wksPredefined && this.wksPredefined.length > 0 ? this.wksPredefined : Constants.OFFLINE_DEFAULT_WORKSPACE;
          })
        );
    } else {
      return of(this.wksPredefined);
    }
  }

  loadWorkspaces(): Observable<Array<any>> {
    const username = this.configService.getUserMarketData() ? this.configService.getUserMarketData().login : this.authService.getUserLogged();

    if (this.existsUserWks()) {
      return of(this.userWorkspaces);
    }

    if (username) {
      const isTokenUserMultiBroker = this.isRanking && this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      // return this.serviceHTTP.doGet(this.configService.getApiWorkspace(), 'api/' + username + '/workspace', null, isTokenUserMultiBroker)
      return this.httpClient.get(`${this.configService.getApiWorkspace()}/api/${username}/workspace`)
        .pipe(
          timeout(20000),
          catchError(() => {
            // return front default workspace
            this.configService.setCookieWorkspace(Constants.WKS_NAME_OFFLINE);
            return of(Constants.OFFLINE_DEFAULT_WORKSPACE);
          }),
          map((response: any) => {
            console.log(response)
            response = response.Data
            if (response && response._isScalar !== false) {
              let arrReturn = [];
              arrReturn = response.filter(wks => wks.WorkspaceType === Constants.WORKSPACE_TYPE.Web);
              if (arrReturn && arrReturn.length > 0) {
                arrReturn.forEach(item => item.Name = JSON.parse(item.JsonData).title);
                this.userWorkspaces = [...arrReturn];
                if (this.userWorkspaces.length > 0) {
                  if (this.configService.getCookieWorkspace()) {
                    this.changeWorkspace(this.configService.getCookieWorkspace());
                    this._initialWorkspaceId.next(this.configService.getCookieWorkspace());
                  } else {
                    this.changeWorkspace(this.userWorkspaces[0].Id);
                    this._initialWorkspaceId.next(this.wksSelectedId);
                  }
                }
                return this.userWorkspaces;
              }
              return [];
            }
            this.configService.setCookieWorkspace(Constants.WKS_NAME_OFFLINE);
            this._initialWorkspaceId.next(this.configService.getCookieWorkspace());
            return Constants.OFFLINE_DEFAULT_WORKSPACE;
          }));
    } else {
      return of([]);
    }
  }

  addWks(newWks): Observable<any> {
    return this.saveWorkspace(newWks)
      .pipe(
        map(data => {
          if (data) {
            this.userWorkspaces.push(data);
            this._onWorkspaceChange.next(this.userWorkspaces);
            this.changeWorkspace(data.Id);
            return true;
          } else {
            return false;
          }
        })
      );
  }

  addWksItens(newWksItens) {
    if (!newWksItens) {
      return;
    }

    this._onAddWKSItem.next(newWksItens);
    const actualWorkspaceToEdit = this.userWorkspaces.find(wks => wks.Id == this.getWksSelectedId());

    if (actualWorkspaceToEdit && actualWorkspaceToEdit.JsonData) {
      const workspaceItemList = JSON.parse(actualWorkspaceToEdit.JsonData);
      if (!workspaceItemList) {
        return;
      }
      newWksItens.forEach(element => {
        workspaceItemList.content.push(element);
      });
      actualWorkspaceToEdit.JsonData = JSON.stringify(workspaceItemList);
      const newWorkspaceToSave = Object.assign({}, actualWorkspaceToEdit);
      newWorkspaceToSave.JsonData = JSON.stringify(Object.assign({}, workspaceItemList));
      this.updateWorkspace(this.getWksSelectedId(), newWorkspaceToSave.JsonData)
        .subscribe(response => {
          if (response && response.Id) {
            const wksToUpdate = this.userWorkspaces.findIndex(wks => wks.Id == response.Id);
            if (wksToUpdate != -1) {
              let tempList = [...this.userWorkspaces];
              tempList[wksToUpdate] = response;
              this.userWorkspaces = [...tempList];
            }
          }
        });
    }
  }

  updateWksById(workspaceChangedId, wksToUpdate): Observable<any> {
    return this.updateWorkspace(workspaceChangedId, wksToUpdate).pipe(
      map(
        response => {
          if (response && response.Id) {
            const wksToUpdate = this.userWorkspaces.findIndex(wks => wks.Id == response.Id);
            if (wksToUpdate != -1) {
              let tempList = [...this.userWorkspaces];
              tempList[wksToUpdate] = response;
              this.userWorkspaces = [...tempList];
            }
            return response;
          } else {
            return null;
          }
        }
      )
    );
  }

  removeWKSItem(itemId, itemType?) {
    this._onRemoveWKSItem.next(itemId);
    const actualWorkspaceToEdit = this.userWorkspaces.find(wks => wks.Id == this.getWksSelectedId());
    const actualWorkspaceToEditIndex = this.userWorkspaces.findIndex(wks => wks.Id == this.getWksSelectedId());
    if (actualWorkspaceToEdit) {
      const workspaceItemList = JSON.parse(actualWorkspaceToEdit.JsonData);
      if (workspaceItemList) {
        const componentToRemove = workspaceItemList.content.findIndex(item => item.id == itemId);
        if (componentToRemove != -1) {
          workspaceItemList.content.splice(componentToRemove, 1);
          const newWorkspaceToSave = Object.assign({}, actualWorkspaceToEdit);
          newWorkspaceToSave.JsonData = JSON.stringify(Object.assign({}, workspaceItemList));
          this.userWorkspaces[actualWorkspaceToEditIndex] = newWorkspaceToSave;
          this.updateWorkspace(this.getWksSelectedId(), newWorkspaceToSave.JsonData)
            .subscribe(response => {
              if (response && response.Id) {
                if (itemType === Constants.WINDOW_NAME_BILLET_ROOT) {
                  this.configService.deleteCookieConfigCards(itemType, true, null);
                } else if (itemType === Constants.WINDOW_NAME_BOOK || itemType === Constants.WINDOW_NAME_QUOTE_CHART) {
                  this.configService.deleteCookieConfigCards(itemType, false, itemId);
                }
                const wksToUpdate = this.userWorkspaces.findIndex(wks => wks.Id == response.Id);
                if (wksToUpdate != -1) {
                  const tempList = [...this.userWorkspaces];
                  tempList[wksToUpdate] = response;
                  this.userWorkspaces = [...tempList];
                }
              }
            });
        }
      }
    }
  }

  deleteUserWks(wksID): Observable<any> {
    return this.deleteWorkspace(wksID)
      .pipe(
        map(() => {
          const itemToRemove = this.userWorkspaces.findIndex(wks => wks.Id == wksID);
          if (itemToRemove != -1) {
            this.userWorkspaces.splice(itemToRemove, 1);
            const selectedWksObj = this.userWorkspaces.find(wks => wks.Id.toString() == this.getWksSelectedId().toString());
            if (selectedWksObj) {
              this.changeWorkspace(selectedWksObj.Id);
            } else {
              this.changeWorkspace(this.userWorkspaces[0].Id);
            }
            return true;
          } else {
            this.notificationService.warn('', Constants.WORKSPACE_MSG026);
            return false;
          }
        }, () => {
          this.notificationService.warn('', Constants.WORKSPACE_MSG026);
          return false;
        })
      )


  }

  verifyIsDefaultWKS() {
    return this.isDefaultWorkspace;
  }

  setLocalWKSAsDefault() {
    this.isDefaultWorkspace = true;
  }

  updateShowMessageToAddWks(data: boolean) {
    this._showMessageToAddWks.next(data);
  }

  updateShowAddWorkspace() {
    if (this.userWorkspaces.length >= Constants.NUM_MAX_WORKSPACES) {
      this._showAddWorkspaces.next(false);
    } else {
      this._showAddWorkspaces.next(true);
    }
  }

  updateWorkspaceLock(data: boolean) {
    this._workspaceLock.next(data);
  }

  getWksSelectedId() {
    return this.wksSelectedId;
  }

  getWorkspaceSelected(): WorkspaceNewDto {
    return this.userWorkspaces.find(wks => wks.Id == this.wksSelectedId);
  }

  getUserWorkspaceById(wksId: number | string): WorkspaceNewDto {
    if (wksId) {
      for (let i = 0; i < this.userWorkspaces.length; i++) {
        if (this.userWorkspaces[i].Id.toString() == wksId.toString()) {
          return this.userWorkspaces[i] as WorkspaceNewDto;
        }
      }
    }
    return null;
  }

  getUserWorkspace(index: number) {
    return this.userWorkspaces[index];
  }

  getUserWorkspaces() {
    return this.userWorkspaces;
  }

  validNumberWorkspace() {
    if (!this.userWorkspaces[0] || this.userWorkspaces[0].Id === undefined || this.userWorkspaces[0].Id === null) {
      return false;
    } else {
      return true;
    }
  }

  resizeComponent(data: { componentId: number, cols: number, rows: number }) {
    this._resizeComponent.next(data);
  }

  getResizeComponent() {
    return this.resizeComponent$;
  }

  existsUserWks() {
    return this.userWorkspaces && this.userWorkspaces.length > 0 && this.userWorkspaces.find(wks => wks.UserName === this.authService.getUserLogged());
  }

  saveWorkspace(workspace: WorkspaceNewSaveDto): Observable<any> {
    if (this.userWorkspaces.length >= Constants.NUM_MAX_WORKSPACES) {
      this.updateShowAddWorkspace();
      return null;
    } else {
      if (this.userWorkspaces.length === (Constants.NUM_MAX_WORKSPACES - 1)) {
        this.updateShowAddWorkspace();
      }
      const username = this.configService.getUserMarketData() ? this.configService.getUserMarketData().login : this.authService.getUserLogged();
      const isTokenUserMultiBroker = this.isRanking && this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
      return this.httpClient
        .post(this.configService.getApiWorkspace() + '/api/workspace/' + username + '/' + Constants.WORKSPACE_TYPE.Web, workspace)
        .pipe(
          map((response: any) => {
            if (response) {
              return response.Data;
            }
            return null;
          })
        )
    }
  }

  updateWorkspace(workspaceId, content): Observable<any> {
    const isTokenUserMultiBroker = this.isRanking && this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
    // Se content for string, tenta fazer o parse para objeto
    let parsedContent = content;
    if (typeof content === 'string') {
      try {
        parsedContent = JSON.parse(content);
      } catch (e) {
        // Se não conseguir fazer o parse, mantém o valor original
      }
    }
    return this.httpClient
      .put(this.configService.getApiWorkspace() + '/api/workspace/' + workspaceId, parsedContent)
      .pipe(
        map((response: any) => {
          if (response) {
            const value = response.Data;
            if (value && value.JsonData) {
              value.Name = JSON.parse(value.JsonData).title; // Treat Workspace Api Bug!
            }
            return value;
          }
          return null;
        })
      )
  }

  deleteWorkspace(workspaceId): Observable<any> {
    const isTokenUserMultiBroker = this.isRanking && this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ? true : false;
    return this.httpClient
      .delete(this.configService.getApiWorkspace() + '/api/workspace/' + workspaceId)
      .pipe(
        map((response: any) => {
          const msg = response.Data;
          if (msg && (msg.status === 200 || msg === 1)) {
            return msg;
          } else {
            throw new Error('Error deleting workspace');
          }
        })
      )
  }

  isNameBlank(newName) {
    if (newName.trim() === '') {
      return true;
    } else {
      return false;
    }
  }

  validateWorkspaceName(newName: string, workspaceChangedId: number): boolean {
    for (let i = 0; i < this.userWorkspaces.length; i++) {
      if (this.userWorkspaces[i].JsonData) {
        const workspace = JSON.parse(this.userWorkspaces[i].JsonData);
        if ((workspace && workspace.title && workspace.title.trim() == newName.trim()) && (this.userWorkspaces[i].Id !== workspaceChangedId)) {
          return false;
        }
      }
    }
    return true;
  }

  getItemDefaultSettings(type: string) {
    for (let i = 0; i < Constants.items_settingsArr.length; i++) {
      if (type == Constants.items_settingsArr[i].type) {
        return Constants.items_settingsArr[i];
      }
    }
    return null;
  }

  mountItemPositionDefaultSettings(itemSettings): PositionDto {
    const wksItemPos: PositionDto = new PositionDto(0, 0, 2, 1);
    if (itemSettings !== null) {
      if (itemSettings.position && itemSettings.position.x !== undefined) {
        wksItemPos.x = itemSettings.position.x;
      }
      if (itemSettings.position && itemSettings.position.y !== undefined) {
        wksItemPos.y = itemSettings.position.y;
      }
      if (itemSettings.position && itemSettings.position.cols !== undefined) {
        wksItemPos.cols = itemSettings.position.cols;
      }
      if (itemSettings.position && itemSettings.position.rows !== undefined) {
        wksItemPos.rows = itemSettings.position.rows;
      }
      if (itemSettings.position && itemSettings.position.dragEnabled !== undefined) {
        wksItemPos.dragEnabled = itemSettings.position.dragEnabled;
      }
      if (itemSettings.position && itemSettings.position.resizeEnabled !== undefined) {
        wksItemPos.resizeEnabled = itemSettings.position.resizeEnabled;
      }
      if (itemSettings.position && itemSettings.position.compactEnabled !== undefined) {
        wksItemPos.compactEnabled = itemSettings.position.compactEnabled;
      }
      if (itemSettings.position && itemSettings.position.maxItemRows !== undefined) {
        wksItemPos.maxItemRows = itemSettings.position.maxItemRows;
      }
      if (itemSettings.position && itemSettings.position.minItemRows !== undefined) {
        wksItemPos.minItemRows = itemSettings.position.minItemRows;
      }
      if (itemSettings.position && itemSettings.position.maxItemCols !== undefined) {
        wksItemPos.maxItemCols = itemSettings.position.maxItemCols;
      }
      if (itemSettings.position && itemSettings.position.minItemCols !== undefined) {
        wksItemPos.minItemCols = itemSettings.position.minItemCols;
      }
      if (itemSettings.position && itemSettings.position.minItemArea !== undefined) {
        wksItemPos.minItemArea = itemSettings.position.minItemArea;
      }
      if (itemSettings.position && itemSettings.position.maxItemArea !== undefined) {
        wksItemPos.maxItemArea = itemSettings.position.maxItemArea;
      }
    }
    return wksItemPos;
  }

  getNextContentItemId(contentArr: Array<WorkspaceItemContentDto>) {
    let max = -1;
    for (let i = 0; i < contentArr.length; i++) {
      if (contentArr[i].id > max) {
        max = contentArr[i].id;
      }
    }
    return max + 1;
  }

  public workspaceSaveOnDemand(box: Box) {
    if (box.symbol.trim() === '' && box.type !== 'worksheet') {
      return;
    }

    const data = this.convertBoxToWorkspaceItemContent(box);
    this.userWorkspaces.forEach(element => {
      if (element.Id === box.workspaceId) {
        const wksObjToUpdate = element as WorkspaceNewDto;
        const itContArrUpdated: Array<WorkspaceItemContentDto> = new Array<WorkspaceItemContentDto>();
        JSON.parse(wksObjToUpdate.JsonData).content.forEach(elem => {
          if (data.id === elem.id) {
            itContArrUpdated.push(data);
          } else {
            itContArrUpdated.push(elem);
          }
        });
        const jsondata = JSON.parse(wksObjToUpdate.JsonData) as WorkspaceNewSaveDto;
        jsondata.content = itContArrUpdated;
        if (this.wksSelectedId && this.wksSelectedId.toString() !== Constants.WKS_NAME_OFFLINE) {
          this.updateWorkspace(box.workspaceId, jsondata).subscribe();
        }
        // FLOW TO SAVE WORKSPACE WHEN A COMPONENT IS EDITED
        const workspaceJson = JSON.parse(this.userWorkspaces[this.userWorkspaces.indexOf(element)].JsonData);
        workspaceJson.content = jsondata.content;
        this.userWorkspaces[this.userWorkspaces.indexOf(element)].JsonData = JSON.stringify(workspaceJson);
      }
    });
  }

  public convertBoxToWorkspaceItemContent(box: Box): WorkspaceItemContentDto {
    const posObj = new PositionDto(box.x, box.y, box.cols, box.rows, box.dragEnabled, box.resizeEnabled,
      box.compactEnabled, box.maxItemRows, box.minItemRows, box.maxItemCols, box.minItemCols, box.minItemArea, box.maxItemArea);
    return new WorkspaceItemContentDto(
      box.id,
      box.symbol,
      box.company,
      box.type,
      posObj,
      box.showInGridster,
      box.workspaceId,
      null,
      null,
      box.worksheetTitle,
      box.columns,
      box['selected_worksheet']
    );
  }

  public revokeAPIWorkspacesToken(token: string) {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
      'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE',
      'Authorization': 'Bearer ' + token,
      // 'x-source-request': 'FastTradeWeb',
      // 'x-source-tracker-id': AppUtils.newguidgen()
    });
    const options = { headers: httpHeaders };
    return this.httpClient
      .post(this.configService.getApiWorkspace() + `/api/token/revoke`, {}, options)
      .pipe(
        map(response => {
          if (response) {
            return response;
          }
          return [];
        }),
        catchError(error => {
          throw error;
        })
      );
  }

  existsWorkspace(): Promise<boolean> {
    return this.loadWorkspaces()
      .toPromise()
      .then(data => {
        return data.length > 0 ? true : false;
      }, () => {
        return false;
      });
  }

  changeWorkspace(selectedWks) {
    this.configService.setCookieWorkspace(selectedWks);
    this.wksSelectedId = selectedWks;
    this._workspaceSelected.next(selectedWks);
    this.updateShowAddWorkspace();
  }

  validateMaxQtdItem(type: string) {
    const wksSelected = this.getWorkspaceSelected();
    const cardConfig = Constants.CARD_CONFIG.find(element => element.type === type);
    if (wksSelected && wksSelected.JsonData && cardConfig && cardConfig.qtdMax !== 0) {
      const workspace = JSON.parse(wksSelected.JsonData);
      const itemType = workspace.content.filter(component => component.type === cardConfig.type).length;
      if (itemType >= cardConfig.qtdMax) {
        return false;
      }
    }
    return true;
  }

  convertDtoContenToSave(jsondata: any): Array<WorkspaceItemContentDto> {
    const contentFrom = jsondata.content;
    const contentTo: Array<WorkspaceItemContentDto> = [];
    for (let k = 0; k < contentFrom.length; k++) {
      const objItem: WorkspaceItemContentDto = new WorkspaceItemContentDto(k, contentFrom[k].symbol,
        contentFrom[k].company, contentFrom[k].type, contentFrom[k].position as PositionDto,
        contentFrom[k].showInGridster || false, contentFrom[k].workspace);
      contentTo.push(objItem);
    }
    return contentTo;
  }

  addItemWorkspace(item, symbol) {
    const actualWorkspace: WorkspaceNewDto = this.getWorkspaceSelected();
    const actualWorkspaceContent: Array<WorkspaceItemContentDto> = JSON.parse(actualWorkspace.JsonData).content;
    const newWorkspaceItem = new CustomWorkspaceItemMultipleDto(null, item.id, [], [], item.title, false);
    if (!this.validateMaxQtdItem(newWorkspaceItem.type)) {
      let msg = Constants.WORKSPACE_MSG024;
      if (newWorkspaceItem.title.toLowerCase().indexOf('boleta') >= 0) {
        newWorkspaceItem.title = newWorkspaceItem.title.split(' ')[0];
      }
      msg = msg.replace('XXX', newWorkspaceItem.title);
      this.notificationService.warn('', msg);
      return;
    }
    if (actualWorkspaceContent['length'] >= Constants.NUM_MAX_WORKSPACE_CARDS) {
      this.notificationService.warn('', Constants.WORKSPACE_MSG011);
      return;
    }
    const workspaceUpdated: WorkspaceNewSaveDto = new WorkspaceNewSaveDto(actualWorkspace.Name, actualWorkspaceContent, actualWorkspace.IndexTab);
    const itemSettings = this.getItemDefaultSettings(newWorkspaceItem.type);
    const wksItemPos: PositionDto = this.mountItemPositionDefaultSettings(itemSettings);
    const company = newWorkspaceItem.company ? newWorkspaceItem.company.toString() : '';
    const wksItemObj: WorkspaceItemContentDto = new WorkspaceItemContentDto(
      this.getNextContentItemId(workspaceUpdated.content),
      symbol ? symbol.toString() : '',
      company,
      newWorkspaceItem.type,
      wksItemPos,
      (itemSettings && itemSettings.showInGridster) || false,
      actualWorkspace.Id || 0,
      item.filter
    );
    this.addWksItens([wksItemObj]);
  }

}
